<template>
  <div class="testbuyerhomepage">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/TestBuyer/Index' }">测买管理</el-breadcrumb-item>
      <el-breadcrumb-item>首页</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="testbuyerinfo" v-if="false">
      <el-row :gutter="30">
        <el-col :span="6" v-for="item in status" :key="item.label">
          <el-statistic :title="item.label">
            <template slot="formatter">{{ item.value }}</template>
          </el-statistic>
        </el-col>
      </el-row>
    </div>
    <div class="testbuyerproductlist">
      <el-table size="mini" :data="testbuylist" v-loading="loading">
        <el-table-column 
          v-for="item in columns"
          :prop="item.prop"
          :key="item.prop"
          :label="item.label"
          :width="item.width"
          :show-overflow-tooltip="item.overflow">
          <template slot="header">
            {{ item.label }}
          </template>
          <template slot-scope="scope">
            <i v-if="item.prop == 'channel'" class="channelicon" :class="setChannel(scope.row.channel).src"></i>
            <button v-else-if="item.prop == 'detail'" class="editskulinkbtn" type="button" @click="viewDetail(scope.row.taskId, scope.row.testId)">
              <i class="el-icon-edit-outline"></i>
            </button>
            <template v-else :class="item.overflow ? 'el-tooltip' : ''">{{ scope.row[item.prop] }}</template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="size"
        layout="total, prev, pager, next, sizes"
        :total="pagingtotal">
      </el-pagination>      
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      // 分配到时间
      status: [{
        label: '全部工单', value: 25
      },{
        label: '待处理', value: 4
      },{
        label: '已完成', value: 12
      },{
        label: '已关闭', value: 9
      }],
      columns: [{
        prop: 'testId', label: '#', width: 100, overflow: false
      },{
        prop: 'time', label: '时间', width: 100, overflow: true
      },{
        prop: 'productName', label: '商品名称', width: false, overflow: true
      },{
        prop: 'shopName', label: '店铺名称', width: 200, overflow: false
      },{
        prop: 'channel', label: '渠道', width: 100, overflow: false
      },{
        prop: 'orderPrice', label: this.$t('jgjk.s23'), width: 100, overflow: false
      },{
        prop: 'detail', label: '详情', width: 60, overflow: false
      },],
      testbuylist: [],
      loading: false,
      page: 1,
      size: 25,
      userid: '',
      pagingtotal: 0
    }
  },

  beforeCreate(){
    $('.kf5-support-chat').remove()
  },

  mounted(){
    let _user = JSON.parse(localStorage.getItem("user")).val
    this.userid = _user.mainid
    this.getTestlists()
  },

  methods: {

    /**
     * 获取订单记录
     */
    getTestlists: function(){
      let that = this
      that.loading = true
      let url = that.API_URL + '/v3/price/testbuy/paging?userId=' + that.userid
      + '&page=' + that.page + '&size=' + that.size
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(res) {
          that.testbuylist = res.results[1]
          that.pagingtotal = res.results[0][0].Count
          that.loading = false
					console.log('getTestlists', res)
        },
        error: function(err) {
          console.log('getTestlists', err)
        }
      })
    },

    viewDetail: function(tid, bid){
      this.$router.push({name: 'TestBuyerDetail', params: {taskId: tid, testId: bid}})
    },

    /**
     * 修改每页显示条数
     */
    handleSizeChange: function(val){
      this.size = val
      this.page = 1
      this.getTestlists()
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getTestlists()
    },

  }
}
</script>